import { useQuery } from '@tanstack/react-query';
import { AI_API } from 'utils/globalApiServices';
import { useRealplayStore } from 'features/realplays/RealPlays.store';
import Organization from 'infrastructure/Organization';

const queryFn = async ({ assignment_uuid, scenario_uuid, session_uuid }) => {
  const org_id = Organization.getSelectedOrg()?.id;
  const url = `/orgs/${org_id}/realplays/assignments/${assignment_uuid}/scenarios/${scenario_uuid}/sessions/${session_uuid}/`;
  const { data } = await AI_API.get(url);
  return data || [];
};

const useGetSessionQuery = ({ assignment_uuid, scenario_uuid, session_uuid, enabled }) => {
  const { updateSessionStatus } = useRealplayStore();
  return useQuery({
    queryFn: () => queryFn({ assignment_uuid, scenario_uuid, session_uuid }),
    queryKey: ['SESSION_INTERACTION_INFO'],
    enabled,
    onSuccess: (response) => {
      updateSessionStatus(response?.status);
    },
  });
};

export default useGetSessionQuery;
